import React from 'react';

import styles from './Image.module.css';

const Image = (props) => {
  return (
    <img
            id="u104_img"
            alt=""
            className={styles.imgD}
            src={props.imageSrc}
          />
  );
};

export default Image;